export default __webpack_public_path__ + "static/media/background.f81f8b29.jpg";